var _module = require('../../components/module');
var _ = require('lodash');
var watch = require('watchjs').watch;

require('angular-local-storage');
require('../search-filter');
require('../favorites');
require('../realtime');
require('../activity-feed');
require('../utils');
require('../analytics');
require('../themes');

_module.requires.push('LocalStorageModule');

_module.config([
    'localStorageServiceProvider',

    function userConfig(localStorageServiceProvider) {
        localStorageServiceProvider.setPrefix('lr-benoit');
    }
]);


/**
 * BaseUser class
 *
 * This provides a base to be used across any
 * other types of User classes we may need.
 */
_module.factory('UserBase', [
    '$log',
    'SearchFilter',

    function userBaseFactory($log, SearchFilter) {
        var defaultOptions = {
            theme: undefined,
            preventLocalSync: false,
            preventRealtime: false
        };

         /*
        UserBase Class

        @param {String} [id] - The id of the user if you want it to autoload the user.
        @param {Object} [props] - Additional properties you would like to set on the user model.
        @param {Object} [options]
        */
        function UserBase(id, props, options) {
            this.id = id || null;
            this.account_type;
            this._options = _.merge(defaultOptions, options);

            if(props) this._setProps(props);
        }

        /*
        Sets properties on the User model

        @function _setProps
        @param {Object} props
        */
        UserBase.prototype._setProps = function _setProps(props) {
            var _this = this;

            Object.keys(props).forEach(function forEachProp(key) {
                if(!~['filters', 'currentFilter'].indexOf(key)) {
                    _this[key] = props[key];
                } else if(key === 'filters' && props.filters.length > 0) {
                    _this[key] = props[key].map(function mapFilters(filterData) {
                        return new SearchFilter(filterData);
                    });
                }
            });

            if(props.currentFilter && this.filters.length > 0) {
                this.currentFilter = _.find(this.filters, { id: props.currentFilter.id }) || null;
            }
        };

        return UserBase;
    }
]);


/**
 * UserLoggedOut Class
 *
 * This provides a user class for when you want allow specifc
 * things that normally would require the user to be loggedin.
 * An example would be the invite search filter mini prefs
 * page. We need to get the users info but want to keep what
 * is allowed to a minimumn so it cant be abused.
 */
_module.factory('UserLoggedOut', [
    '$log',
    '$q',
    '$http',
    'UserBase',

    function userLoggedOutFactory($log, $q, $http, UserBase) {
        /**
         * UserLoggedOut Class
         *
         * @param {String} [id] - The id of the user if you want it to autoload the user.
         */
        function UserLoggedOut(id) {
            UserBase.apply(this, arguments);

            this.errorFetchingUser = false;

            this._fetch();
        }

        UserLoggedOut.prototype = Object.create(UserBase.prototype);
        UserLoggedOut.prototype.constructor = UserLoggedOut;


        /////////////////////////
        // Internal Functions
        /////////////////////////

        /**
         * Fetches the latest user info from the server
         *
         * @function _fetch
         * @return {Promise}
         */

        UserLoggedOut.prototype._fetch = function _fetch() {
            var _this = this;

            return $http.get('/v1/users/' + this.id)
            .then(function getUserResponse(response) {
                $log.debug('GET USER', response);

                _this._setProps(response.data.data);

                return _this;
            })
            .catch(function onError(err) {
                $log.error(err);

                this.errorFetchingUser = err;
                delete _this.id; // We want it to generate a new id

                Object.keys(_this).forEach(function deleteProps(prop) {
                    delete _this[prop];
                });
            });
        };


        /////////////////////////
        // Public Functions
        /////////////////////////

        /**
         * @function sendBuyerAgentUpdatedEmail
         */
        UserLoggedOut.prototype.sendBuyerAgentUpdatedEmail = function sendBuyerAgentUpdatedEmail() {
            return $http.post('/v1/emails/buyer-agent-updated', { userId: this.id })
            .then(function (response) {
                return response.data.data;
            })
            .catch(function onError(err) {
                $log.error('UserLoggedOut -> sendBuyerAgentUpdatedEmail -> Error', err);
                throw err;
            });
        };


        return UserLoggedOut;
    }
]);


/**
 * User Class
 *
 * This is the main class used to mange the current user
 * on the application.
 */
_module.factory('User', [
    '$log',
    '$rootScope',
    '$q',
    '$http',
    '$timeout',
    '$favorites',
    '$location',
    'SearchFilter',
    'localStorageService',
    'realTime',
    '$activityFeed',
    '$utils',
    '$analytics',
    '$themes',
    'UserBase',

    function userFactory($log, $rootScope, $q, $http, $timeout, $favorites, $location, SearchFilter, localStorageService, realTime, $activityFeed, $utils, $analytics, $themes, UserBase) {
        /*
        User Class

        @param {String} [id] - The id of the user if you want it to autoload the user.
        @param {Object} [props] - Additional properties you would like to set on the user model.
        @param {Object} [options]
        @param {String} [options.theme] - Used to overwrite the users theme code.
        @param {Boolean} [options.preventLocalSync=false]
        @param {Boolean} [options.preventRealtime=false]
        */
        function User(id, props, options) {
            UserBase.apply(this, arguments);

            var _this = this;

            this.filters = [];
            this.favorites = [];
            this.isNew = id? false : true;
            this.waitingForLogin = false;
            this.currentFilter = null;
            this.isLoggedIn = false;
            this.attemptedLogin = false;
            this.loadingFilters = true;
            this.loadingFavorites = true;

            this._setTheme();

            if(!this.affiliateId) {
                if($location.search().affiliate) {
                    this.affiliateId = $location.search().affiliate;
                } else if($location.search().a && $utils.parseAuthQueryParam()) {
                    var authObj = $utils.parseAuthQueryParam();
                    this.affiliateId = authObj.affiliateId;
                }
            }

            if(this.affiliateId) {
                this._fetchAffiliate($location.search().affiliate ? true : false);
            }

            if(this.isNew) {
                this._createUser();
            } else {
                this._fetch();
                this._fetchFilters();
                this._fetchFavorites();
            }

            // $rootScope listeners
            $rootScope.$on(SearchFilter.SEARCH_FILTER_SAVED, function onSearchFilterSaved(e, searchFilter, isNew) {
                var filter = _.find(_this.filters, { id: searchFilter.id }) || null;

                $log.debug('Filter Saved', searchFilter.id, filter);
                $log.debug('Filter is New', isNew);

                if(isNew && _this.account_type !== 'guest') {
                    $activityFeed.add({
                        avatar: 'initials',
                        type: 'lead',
                        name: 'benoit_filter_created_by_user',
                        userId: _this.affiliateId,
                        meta: {
                            benoitPartnerId: _this.affiliate.benoitPartnerId,
                            benoitUserId: _this.id,
                            name: _this.full_name,
                            first_name: _this.first_name,
                            last_name: _this.last_name,
                            searchFilterId: searchFilter.id,
                            search_filter_name: searchFilter.name
                        }
                    });
                }

                if(filter) {
                    if(_this.currentFilter && filter.id === _this.currentFilter.id) {
                        _this.currentFilter = filter;
                    }

                    _this._syncLocal();
                }
            });

            $rootScope.$on(SearchFilter.SEARCH_FILTER_DELETED, function onSearchFilterDeleted(e, searchFilter) {
                var index = _.findIndex(_this.filters, { id: searchFilter.id });

                if(~index) {
                    _this.filters.splice(index, 1);
                    _this._syncLocal();
                }
            });

            watch(this, 'currentFilter', function onCurrentFilterChange(prop) {
                if(prop === 'currentFilter') {
                    $log.debug('Current Filter Changed', arguments);

                    _this._syncLocal();
                }
            }, 0, true);
        }

        User.prototype = Object.create(UserBase.prototype);
        User.prototype.constructor = User;

        User.LOGGED_IN = 'User:Loggedin';
        User.LOGGED_IN_WAITING_EXPIRED = 'User:LoggedinWaitingExpired';
        User.SHOW_ACTIVATE_DEVICE_MODAL = 'User:ShowActivateDeviceModal';

        /////////////////////////
        // Internal Functions
        /////////////////////////

        /*
        Sets the theme

        @function _setTheme
        */
        User.prototype._setTheme = function _setTheme() {
            var theme = _.get(this, '_options.theme') || _.get(this.affiliate, 'customizations.theme');
            if(theme) $themes.setTheme(theme);
        };

        /*
        Connects to realtime

        @function _initRealtime
        */
        User.prototype._initRealtime = function _initRealtime() {
            if(this._options.preventRealtime) return;

            $log.debug('ID', this.id);

            if(this.waitingForLogin) return;

            var _this = this;

            realTime.connect(this.id, 'dashboard');

            realTime.on('user-updated', function (data) {
                $log.debug('User Updated', data);

                _this._setProps(data.user);
                _this._syncLocal();
            });
        };

        /*
        Returns an object containing only keys that
        can be saved to the database / localstorage

        @function _getSavableObj
        */
        User.prototype._getSavableObj = function _getSavableObj() {
            var _this = this;
            var propExceptions = [
                'attemptedLogin',
                'isLoggedIn',
                'isNew',
                'filters',
                'bearer_token',
                'currentFilter',
                'waitingForLogin',
                'affiliate',
                'loadingFilters',
                'favorites',
                'loadingFavorites',
                '_options',
                'currentSearch'
            ];
            var data = Object.keys(this).reduce(function reduceData(obj, key) {
                if(!~propExceptions.indexOf(key) && _this[key] !== null) {
                    obj[key] = _this[key];
                }

                return obj;
            }, {});

            return data;
        };

        /*
        Creates a new user account

        @function _createUser
        */
        User.prototype._createUser = function _createUser() {
            this.account_type = 'guest';

            var _this = this;
            var data = this._getSavableObj();

            return $http.post('/v1/users', data)
                .then(function createUserResponse(response) {
                    _this._setProps(response.data.data);

                    _this.isNew = false;
                    _this.attemptedLogin = true;
                    _this.isLoggedIn = true;

                    _this._syncLocal();
                    _this._initRealtime();

                    return _this;
                })
                .catch(function createUserError(err) {
                    $log.error(err);
                });
        };

        /*
        Fetches the latest user info from the server

        @function _fetch
        @return {Promise}
        */
        User.prototype._fetch = function _fetch() {
            var _this = this;

            return $http.get('/v1/users/' + this.id)
                .then(function getUserResponse(response) {
                    $log.debug('GET USER', response);

                    _this._setProps(response.data.data);

                    _this.isNew = false;
                    _this.attemptedLogin = true;
                    _this.isLoggedIn = true;

                    _this._syncLocal();
                    _this._initRealtime();

                    if(_this.account_type !== 'guest') $activityFeed.updateLastSeen(_this);

                    return _this;
                })
                .catch(function createUserError(err) {
                    $log.error(err);

                    _this.filters.length = 0;
                    _this.currentFilter = null;
                    _this.favorites.length = 0;

                    delete _this.id; // We want it to generate a new id

                    var propExceptions = [
                        'attemptedLogin',
                        'isLoggedIn',
                        'isNew',
                        'waitingForLogin',
                        'loadingFilters',
                        'loadingFavorites'
                    ];

                    Object.keys(_this).forEach(function deleteProps(prop) {
                        if(!~propExceptions.indexOf(prop)) {
                            delete _this[prop];
                        }
                    });

                    return _this._createUser();
                });
        };

        /*
        Fetches a users filters

        @function _fetchFilters
        */
        User.prototype._fetchFilters = function _fetchFilters() {
            var _this = this;

            return $http.get('/v1/users/' + this.id + '/search-filters')
                .then(function getSearchFiltersResponse(response) {
                    $log.debug('GET SEARCH FILTERS', response);

                    _this._setProps({ filters: response.data.data });
                    _this.loadingFilters = false;
                    $rootScope.$broadcast('search-filters-loaded');
                    _this._syncLocal();

                    return _this;
                })
                .catch(function searchFiltersError(err) {
                    $log.error('Get Search Filters Error:', err);
                });
        };


        /*
        Fetches a users favorites

        @function _fetchFavorites
        */
        User.prototype._fetchFavorites = function _fetchFavorites() {
            var _this = this;

            return $favorites.getAll(this.id)
            .then(function getFavoritesResponse(response) {
                $log.debug('GET FAVORITES', response);

                _this._setProps({ favorites: response });
                _this.loadingFavorites = false;
                _this._syncLocal();

                return _this;
            })
            .catch(function getFavoritesError(err) {
                $log.error('Error fetching user favorites: ', err);
            });
        };

        User.prototype.isAffliateLoanOfficer = function(affiliate) {
            if(affiliate.benoit_partner && affiliate.benoit_partner.website){
                return true;
            } else if(!affiliate.benoit_partner && affiliate.website){
                return true;
            } else {
                return false;
            }
        };

        /*
        Fetches the affiliates info

        @function _fetchAffiliate
        @param {Boolean} shouldSave - Whether we should save after fetching. Defaults to false.
        */
        User.prototype._fetchAffiliate = function _fetchAffiliate(shouldSave) {
            var _this = this;

            /*
            Picks an affiliate user's company address and office phone
            and returns a formatted object with the keys - company_address and secondary_phone
            */

            var _formatBranchInfo = function _formatBranchInfo(userObj) {
                var joinAddressComponents = function joinAddressComponents(components) {
                    var formatted_address;
                    if(components) {
                        if(typeof components === 'string' && components.length) {
                            formatted_address = components;
                        } else if(components.street && components.city && components.state && components.zip &&
                            components.street.length && components.city.length && components.state.length && components.zip.length ) {

                            formatted_address = [components.street];
                            if(components.street2 && components.street2.length) {
                                var street2 = (components.street2.match(/[a-z]/i)) ? components.street2 : '#' + components.street2;
                                formatted_address.push(street2);
                            }
                            formatted_address.push(',');
                            formatted_address.push(components.city + ',');
                            formatted_address.push(components.state + ',');
                            formatted_address.push(components.zip);
                            formatted_address = formatted_address.join(' ').replace(/,+/g,','); // remove any multiple commas from joined string
                        } else if(components.address && components.address.length){
                            formatted_address = components.address;
                        } else if(components.formatted_address && components.formatted_address.length){
                            formatted_address = components.formatted_address;
                        }
                    }
                    return formatted_address;
                };

                var getCompanyAddress = function getCompanyAddress(aff) {
                    var companyAddress;
                    if(aff && aff.licensed_address &&
                        ((aff.licensed_address.street && aff.licensed_address.street.length) ||
                        (aff.licensed_address.formatted_address && aff.licensed_address.formatted_address.length))) {
                        companyAddress = joinAddressComponents(aff.licensed_address);
                    } else if(aff && aff.vendor && aff.vendor.meta) {
                        companyAddress = joinAddressComponents(aff.vendor.meta);
                    }
                    return companyAddress;
                };

                var getOfficePhone = function getOfficePhone(aff) {
                    var offPhone;
                    if(aff && aff.office_phone) {
                        offPhone = aff.office_phone;
                    } else if(aff && aff.vendor && aff.vendor.meta && aff.vendor.meta.phone && aff.vendor.meta.phone.length) {
                        offPhone = aff.vendor.meta.phone;
                    }
                    return offPhone;
                };

                return (userObj) ? _.extend(userObj, {
                    company_address: getCompanyAddress(userObj),
                    phone_secondary: getOfficePhone(userObj)
                }) : userObj;
            };

            return $http.get('/v1/affiliates/' + this.affiliateId)
                .then(function getAffiliateResponse(response) {
                    _this.affiliate = response.data.data.affiliate;

                    if(_this.affiliateId !== _this.affiliate.id)  _this.affiliateId = _this.affiliate.id;

                    if(_this.affiliate && _this.affiliate.benoit_partner) {
                        _this.affiliate.benoit_partner = _formatBranchInfo(_this.affiliate.benoit_partner);
                    }
                    _this.affiliate = _formatBranchInfo(_this.affiliate);

                    if(shouldSave) _this.save();

                    _this._setTheme();
                    return _this.affiliate;
                });
        };

        /*
        Saves the user data to local storage.

        @function _syncLocal
        */
        User.prototype._syncLocal = function _syncLocal() {
            this._options = this._options || {};
            if(this._options.preventLocalSync || ~$location.absUrl().indexOf('/accounts/devices')) return;

            var data = this._getSavableObj();

            if(this.filters) {
                data.filters = this.filters.map(function mapFilters(filter) {
                    return filter._getSavableObj();
                });
            }

            data.currentFilter = this.currentFilter;
            data.affiliate = this.affiliate;
            data.favorites = this.favorites;

            localStorageService.set('user', data);

            $log.debug('local storage', localStorageService.get('user'));
        };

        /*
        Saves the users info to the database

        @function _syncRemote
        */
        User.prototype._syncRemote = function _syncRemote() {
            var data = this._getSavableObj();

            return $http.put('/v1/users/' + this.id, data)
                .then(function updateUserResponse(response) {
                    return response.data.data;
                });
        };

        /*
        Delete the users guest account

        @function _deleteGuestAccount
        */
        User.prototype._deleteGuestAccount = function _deleteGuestAccount() {
            return $http.delete('/v1/users/guests/' + this.id, { headers: { Authorization: 'Bearer ' + this.bearer_token } });
        };


        ////////////////////////
        // Public Functions
        ////////////////////////

        /*
        Save the user to the database and local storage.

        @function save
        */
        User.prototype.save = function save() {
            var _this = this;

            return this._syncRemote()
                .then(function onSyncRemoteSuccess() {
                    _this._syncLocal();

                    return _this;
                });
        };

        /*
        Add a search filter to the users filters

        @function addSearchFilter
        @param {SearchFilter} searchFilter
        */
        User.prototype.addSearchFilter = function addSearchFilter(searchFilter, setAsCurrentSearchFilter) {
            this.filters.push(searchFilter);
            if(setAsCurrentSearchFilter) this.currentFilter = searchFilter;

            this._syncLocal();

            return this.filters;
        };

        /*
        Get a search filter

        @function getSearchFilter
        @param {String} id
        @returns promise
        */
        User.prototype.getSearchFilter = function getSearchFilter(id) {
            var _this = this;
            var filter = _.find(_this.filters, { id: id }) || null;
            var promise;

            if(filter) {
                promise = filter;
            } else {
                promise = $http.get('/v1/searchfilters/' + id)
                    .then(function getFilterResponse(response) {
                        return new SearchFilter(response.data.data);
                    })
                    .catch(function getSearchFilterError(err) {
                        $log.error(err.data.errors[0], err);

                        return null;
                    });
            }

            return $q.when(promise)
                .then(function success(response) {
                    return response;
                });
        };

        /*
        Send our verification email and text

        @function sendAccountVerification
        @param {String} [redirectTo]
        @returns promise
        */
        User.prototype.sendAccountVerification = function sendAccountVerification(redirectTo) {
            var promises = [
                this.sendPhoneVerification(redirectTo)
            ];

            if(this.email) promises.push(this.sendEmailVerification(redirectTo));

            return $q.all(promises)
                .then(function sendResponses(response) {
                    return true;
                });
        };

        /*
        Sends the text verification message

        @function sendPhoneVerification
        @param {String} [redirectTo]
        */
        User.prototype.sendPhoneVerification = function sendPhoneVerification(redirectTo) {
            var postData = {
                redirect: redirectTo || null
            };

            return $http.post('/v1/users/' + this.id + '/account-verification-code/phone', postData)
                .then(function phoneVerificationResponse(response) {
                    return response.data.data;
                });
        };

        /*
        Sends the email address verification email

        @function sendEmailVerification
        @param {String} [redirectTo]
        */
        User.prototype.sendEmailVerification = function sendEmailVerification(redirectTo) {
            var postData = {
                redirect: redirectTo || null
            };

            return $http.post('/v1/users/' + this.id + '/account-verification-code/email', postData)
                .then(function emailVerificationResponse(response) {
                    return response.data.data;
                });
        };

        /*
        Logs a user out

        @function logout
        */
        User.prototype.logout = function logout() {
            localStorageService.clearAll();

            window.location = '/';
        };

        /*
        Log in a user

        @function login
        @param {String} type - phone or email
        @param {String} value
        @return {Promise}
        */
        User.prototype.login = function login(type, value) {
            var _this = this;
            var postData = {
                type: type,
                value: value
            };

            return $http.post('/v1/users/login', postData)
                .then(function loginResponse(response) {
                    var expires = response.data.data.expires;
                    var token = response.data.data.token;

                    localStorageService.set('wtl', { e: expires, t: token });
                    // _this.waitForLoginMessage(token);

                    return true;
                });
        };

        /*
        Activates the users device using a 4 digit code

        @function activateDevice
        @param {String} code - 4 digit code the user received in an email or text
        @return {Promise}
        */
        User.prototype.activateDevice = function activateDevice(code) {
            var _this = this;
            var wtl = localStorageService.get('wtl');

            if(new Date(wtl.e).getTime() < new Date().getTime()) {
                return $q.reject({
                    title: 'Expired',
                    detail: 'Oops! It looks like this 4 Digit Login Code has expired. Please login again.'
                });
            }

            var postData = {
                code: code,
                token: wtl.t
            };

            return $http.post('/v1/accounts/devices/activate', postData)
            .then(function success(response) {
                $log.debug('allow-login', response.data);

                var userData = response.data.data;
                var promise = null;

                if(_this.account_type === 'guest') {
                    promise = _this._deleteGuestAccount();
                }

                $q.when(promise)
                    .catch(function deleteGuestError(err) {
                        $log.error(err.data);
                    })
                    .finally(function () {
                        localStorageService.remove('wtl');
                        localStorageService.set('user', {
                            id: userData.id,
                            affiliate: userData.affiliate,
                            affiliateId: userData.affiliateId,
                            email: userData.email,
                            first_name: userData.first_name,
                            last_name: userData.last_name,
                            full_name: userData.full_name
                        });

                        $rootScope.$broadcast(User.LOGGED_IN, userData);

                        $timeout(function refreshBrowser() {
                            if(~$location.absUrl().indexOf('accounts/invites/accepted')) {
                                window.location = '/?psffr=true';
                            } else {
                                location.reload();
                            }
                        }, 0);
                    });
            })
            .catch(function onError(err) {
                $log.error('/v1/accounts/devices/activate', err);

                return $q.reject(err.data.errors[0]);
            });
        };

        /*
        DEPRECATED - 6-2-16
        Listens fot a allow login message

        @function waitForLoginMessage
        @param {String} token
        */
        User.prototype.waitForLoginMessage = function waitForLoginMessage(token) {
            $log.warn('DEPRECATED: waitForLoginMessage has been DEPRECATED. Please use the activateDevice method instead');

            // var _this = this;
            // var retryDelay = 1000;
            // var maxRetries = 600; // 10 mins worth
            // var to;

            // this.waitingForLogin = true;

            // function login() {
            //     $timeout.cancel(to);

            //     $http.get('/v1/accounts/devices/' + token + '/activated')
            //         .then(function success(response) {
            //             $log.debug('allow-login', response.data);

            //             var data = response.data.data;
            //             var promise = null;

            //             if(_this.account_type === 'guest') {
            //                 promise = _this._deleteGuestAccount();
            //             }

            //             $q.when(promise)
            //                 .catch(function deleteGuestError(err) {
            //                     $log.error(err.data);
            //                 })
            //                 .finally(function () {
            //                     localStorageService.remove('wtl');
            //                     localStorageService.set('user', { id: data.user.id, affiliateId: data.user.affiliateId });

            //                     $rootScope.$broadcast(User.LOGGED_IN, data.user);

            //                     $timeout(function refreshBrowser() { location.reload(); }, 0);
            //                 });
            //         })
            //         .catch(function error(err) {
            //             if(err.status === 401) {
            //                 if(--maxRetries > 0) {
            //                     to = $timeout(login, retryDelay);
            //                 } else {
            //                     alert('Your login has expired. Please try logging in again.');
            //                     localStorageService.remove('wtl');
            //                     $rootScope.$broadcast(User.LOGGED_IN_WAITING_EXPIRED);
            //                 }
            //             } else {
            //                 $log.error('waitForLoginMessage Error', err);
            //             }
            //         });
            // }

            // login();

            // ------------------------------------------------------------------------------------------------------------

            // realTime.connect(token, 'waiting-to-login');
            // realTime.once('allow-login', function allowLogin(data) {
            //     $log.debug('allow-login', data);

            //     var promise = null;

            //     if(_this.account_type === 'guest') {
            //         promise = _this._deleteGuestAccount();
            //     }

            //     $q.when(promise)
            //         .catch(function deleteGuestError(err) {
            //             $log.error(err.data);
            //         })
            //         .finally(function () {
            //             localStorageService.remove('user');
            //             localStorageService.remove('wtl');
            //             localStorageService.set('user', { id: data.user.id, affiliateId: data.user.affiliateId });

            //             $rootScope.$broadcast(User.LOGGED_IN, data.user);

            //             setTimeout(function refreshBrowser() { location.reload(); }, 500);
            //         });
            // });
        };

        /*
        Sets the affiliate ID if it is valid

        @function setAffiliateId
        @param {String} affiliateId
        @returns {Promise}
        */
        User.prototype.setAffiliateId = function setAffiliateId(affiliateId) {
            var _this = this;

            return $http.get('/v1/affiliates/' + affiliateId)
                .then(function getAffiliateResponse(response) {
                    var affiliate = response.data.data.affiliate;
                    _this.affiliateId = affiliate.id;
                    _this.affiliate = affiliate;

                    return _this.save();
                });
        };


        /*
        Add a listing to the users favorites

        @function addFavorite
        @param {Object} postBody
        @param {String} listing_id - The id of the listing to be favorited
        @param {String} listing_source
        @param {Object} listing - A snapshot of the listing data object when it is being favorited
        @param {String} searchFilterId - (Optional) Will be the searchFilter's id if the listing is part of the filter's results.
                        Will not be present if the listing was a part of a direct search.
        */
        User.prototype.addFavorite = function addFavorite(postBody) {
            var _this = this;

            var encodedListingId = postBody.listing_id;
            postBody.ownerId = _this.id;

            return $favorites.favorite(postBody)
                .then(function (response) {
                    $log.debug('Favorited', response);

                    if(response && response.data) {
                        var data = response.data;
                        data.listing_id = encodedListingId; // ensures we use the encoded id on the front end
                        if(data.listing) {
                            data.listing.id = encodedListingId;
                        }
                        _this.favorites.push(data);
                        _this._syncLocal();
                    }else {
                        $log.debug('Invalid response from $favorites.favorite', response);
                    }
                    return response;
                });
        };


        /*
        Remove a listing from the users favorites

        @function removeFavorite
        @param {String} id - The favoriteId
        */
        User.prototype.removeFavorite = function removeFavorite(id) {
            var _this = this;

            return $favorites.unfavorite(id)
                .then(function (response) {
                    _this.favorites = _this.favorites.filter(function (f) { return f.id !== id; });
                    _this._syncLocal();
                    return response;
                });
        };


        /*
        Sends the prequal notifications to LO when
        the user clicks the Pre Qualify button

        @function sendPreQualifyClickedNotifications
        @param {Object} postData
        */
        User.prototype.sendPreQualifyClickedNotifications = function sendPreQualifyClickedNotifications(postData) {
            var _this = this;

            if(postData) {
                postData.full_name = _this.full_name;
                postData.phone = _this.phone;
                postData.email = _this.email;

                return $http.post('/v1/users/' + _this.id + '/pre-qualify-notifications', postData)
                .then(function sendPreQualifyClickedNotificationsResponse(response) {
                    return response.data.data;
                });
            }
        };


        /*
        Sends the show me the home notifications to the Agent and LO
        when the user clicks the Show Me the Home notifications button

        @function sendShowMeTheHomeNotifications
        @param {Object} listing
        @param {Object} agent
        @param {Object} vendorUser
        */
        User.prototype.sendShowMeTheHomeNotifications = function sendShowMeTheHomeNotifications(listing, agent, vendorUser) {
            var _this = this;
            var postData = {
                address: listing.address,
                agent: _.pick(agent, ['id', 'email', 'phone', 'first_name', 'last_name', 'name']),
                vendor_user: _.pick(vendorUser, ['id', 'email', 'phone', 'first_name', 'last_name', 'name'])
            };

            return $http.post('/v1/users/' + _this.id + '/show-me-the-home-notifications', postData)
            .then(function sendShowMeTheHomeNotificationsResponse(response) {
                return response.data.data;
            });
        };


        /*
        Deletes the current user's account
        Saves the reason for deletion in

        @function delete
        */
        User.prototype.delete = function deleteAccount(reason) {
            var _this = this;
            return $http.delete('/v1/users/' + _this.id, { headers: { Authorization: 'Bearer ' + this.bearer_token } })
                .then(function (response) {
                    var eventName = 'nest.me Account Delete Submit';
                    var eventData = {
                        'Affiliate Name': _this.affiliate.name,
                        'Affiliate Company': _this.affiliate.company,
                        'Affiliate Email': _this.affiliate.email,
                        'Affiliate Code': _this.affiliate.affiliate_code,
                        'Vendor Name': _.get(_this, 'affiliate.benoit_partner.name'),
                        'Vendor Company': _.get(_this, 'affiliate.benoit_partner.company'),
                        'Vendor Email': _.get(_this, 'affiliate.benoit_partner.email'),
                        'Consumer Name': _this.full_name,
                        'Consumer ID': _this.id,
                        'Reason For Leaving': reason
                    };
                    $analytics.eventTrack(eventName, eventData);
                    $activityFeed.add({
                        id: _this.id + '_deleted_benoit_user',
                        avatar: 'initials',
                        type: 'lead',
                        name: 'benoit_user_deleted_account',
                        userId: _this.affiliateId,
                        meta: {
                            benoitPartnerId: _this.affiliate.benoitPartnerId,
                            benoitUserId: _this.id,
                            name: _this.full_name,
                            first_name: _this.first_name,
                            last_name: _this.last_name,
                            reason_for_leaving: reason
                        }
                    });
                    return response.data;
                });
        };


        return User;
    }
]);


// $user Service
_module.service('$user', [
    '$log',
    '$rootScope',
    '$location',
    'localStorageService',
    'User',
    '$timeout',

    function userService($log, $rootScope, $location, localStorageService, User, $timeout) {
        var user;
        var wtl = localStorageService.get('wtl');
        var additionalData = {
            refCodeId: $location.search().ref
        };
        var options = {};

        if($location.search().preview_theme) {
            options.theme = $location.search().preview_theme;
        }

        if(
            localStorageService.get('user') &&
            localStorageService.get('user').id &&
            !(~$location.absUrl().indexOf('/cmlsp') || ~$location.absUrl().indexOf('/logout'))
        ) {
            user = new User(
                localStorageService.get('user').id,
                _.merge(localStorageService.get('user'), additionalData),
                options
            );
        } else {
            user =  new User(
                undefined,
                additionalData,
                options
            );
        }

        if(!~$location.absUrl().indexOf('/accounts/devices') || !~$location.absUrl().indexOf('/cmlsp')) {
            if(wtl && new Date(wtl.e).getTime() > new Date().getTime()) {
                // user.waitForLoginMessage(wtl.t);
                $timeout(function () {
                    $rootScope.$broadcast(User.SHOW_ACTIVATE_DEVICE_MODAL);
                }, 1);
            } else {
                localStorageService.remove('wtl');
            }
        }

        return user;
    }
]);
